/**
 * Default service container — Phase 6a.5 per spec §8.3.
 *
 * Singleton wiring of concrete implementations. Tests / Storybook can
 * override individual services by passing a custom container to
 * <ServiceProvider value={…}>.
 */

import {
  ManualFxRateProvider,
  RestCalculationService,
  RestEngagementService,
  StubAiAssistant,
  SupabaseHistoryStorage,
} from "./implementations";
import type {
  AiAssistant,
  CalculationService,
  EngagementService,
  FxRateProvider,
  HistoryStorage,
} from "./interfaces";

export interface ServiceContainer {
  calculationService: CalculationService;
  engagementService: EngagementService;
  fxRateProviders: FxRateProvider[];
  historyStorage: HistoryStorage;
  aiAssistant: AiAssistant;
}

export const container: ServiceContainer = {
  calculationService: new RestCalculationService(),
  engagementService: new RestEngagementService(),
  fxRateProviders: [new ManualFxRateProvider()],
  historyStorage: new SupabaseHistoryStorage(),
  aiAssistant: new StubAiAssistant(),
};
